import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface WorkflowTriggerState {
  loading: boolean;
  success: boolean;
  message: string | null;
  error: string | null;
  restaurantId: string | null;
}

const initialState: WorkflowTriggerState = {
  loading: false,
  success: false,
  message: null,
  error: null,
  restaurantId: null,
};

const workflowTriggerSlice = createSlice({
  name: 'workflowTrigger',
  initialState,
  reducers: {
    triggerWorkflowRequest: (state, action: PayloadAction<{ restaurantId: string }>) => {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.message = null;
    },
    triggerWorkflowSuccess: (state, action: PayloadAction<{ success: boolean; message: string; restaurant_id: string }>) => {
      state.loading = false;
      state.success = action.payload.success;
      state.message = action.payload.message;
      state.restaurantId = action.payload.restaurant_id;
      state.error = null;
    },
    triggerWorkflowFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      state.message = null;
    },
    resetWorkflowTrigger: (state) => {
      state.loading = false;
      state.success = false;
      state.message = null;
      state.error = null;
      state.restaurantId = null;
    },
  },
});

export const {
  triggerWorkflowRequest,
  triggerWorkflowSuccess,
  triggerWorkflowFailure,
  resetWorkflowTrigger,
} = workflowTriggerSlice.actions;

export default workflowTriggerSlice.reducer;
